"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPendingConnectionHttp = isPendingConnectionHttp;
function isPendingConnectionHttp(connection) {
    return !('connectEvent' in connection);
}
